import { render, staticRenderFns } from "./DialogMenu.vue?vue&type=template&id=2a27965c&scoped=true"
import script from "./DialogMenu.vue?vue&type=script&lang=js"
export * from "./DialogMenu.vue?vue&type=script&lang=js"
import style0 from "./DialogMenu.vue?vue&type=style&index=0&id=2a27965c&prod&lang=scss"
import style1 from "./DialogMenu.vue?vue&type=style&index=1&id=2a27965c&prod&scoped=true&lang=css"
import style2 from "./DialogMenu.vue?vue&type=style&index=2&id=2a27965c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a27965c",
  null
  
)

export default component.exports